import {
  BrowserRouter,
  Routes,
  Route,
  Outlet,
  Navigate,
} from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import SideMenu from "./Components/SideMenu";
import AppTheme from "./theme/AppTheme";
import {
  chartsCustomizations,
  dataGridCustomizations,
  datePickersCustomizations,
  treeViewCustomizations,
} from "./theme/customizations";
import SoftwareAccess from "./Pages/SoftwareAccess";
import Holiday from "./Pages/Holiday";
import HolidayForm from "./Pages/HolidayForm";
import Dashboard from "./Pages/Dashboard";
import Employees from "./Pages/Employees";
import EmployeesForm from "./Pages/EmployeesForm";
import SignIn from "./Pages/SignIn";
import { useSession, SessionProvider } from "./Services/AuthContext";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "leaflet/dist/leaflet.css";
import TermsAndConditions from "./Pages/TermsAndConditions";
import SoftwareAccessForm from "./Pages/SoftwareAccessForm";
import Department from "./Pages/Department";
import DepartmentForm from "./Pages/DepartmentForm";

const xThemeComponents = {
  ...chartsCustomizations,
  ...dataGridCustomizations,
  ...datePickersCustomizations,
  ...treeViewCustomizations,
};

function ProtectedRoute() {
  const { isLoading, session } = useSession();

  if (isLoading) {
    return null;
  }

  if (!session) {
    return <Navigate to="/" replace />;
  }

  return (
    <>
      <SideMenu />
      <Box
        component="main"
        sx={{ flexGrow: 1, maxHeight: "100vh", overflow: "hidden" }}
      >
        <Outlet />
      </Box>
    </>
  );
}

export default function App(props) {
  return (
    <SessionProvider>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <AppTheme {...props} themeComponents={xThemeComponents}>
          <CssBaseline enableColorScheme />
          <BrowserRouter>
            <Box sx={{ display: "flex" }}>
              <Routes>
                <Route path="/" element={<SignIn />} />
                <Route
                  path="/TermsAndConditions"
                  element={<TermsAndConditions />}
                />
                <Route element={<ProtectedRoute />}>
                  <Route path="/home" element={<Dashboard />} />
                  <Route path="/employees" element={<Employees />} />
                  <Route path="/employees/form" element={<EmployeesForm />} />
                  <Route path="/holiday" element={<Holiday />} />
                  <Route path="/holiday/form" element={<HolidayForm />} />
                  <Route path="/software-access" element={<SoftwareAccess />} />
                  <Route
                    path="/software-access/form"
                    element={<SoftwareAccessForm />}
                  />
                  <Route path="/department" element={<Department />} />
                  <Route path="/department/form" element={<DepartmentForm />} />
                </Route>
                <Route
                  path="*"
                  element={
                    <Box
                      sx={{
                        width: "100vw",
                        height: "100vh",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <h1>404 Not Found</h1>
                    </Box>
                  }
                />
              </Routes>
            </Box>
          </BrowserRouter>
        </AppTheme>
      </LocalizationProvider>
    </SessionProvider>
  );
}
